<template>
    <div class="rwps__filter-drawer__inner">
        <header class="rwps__filter-drawer__header d-flex align-items-center justify-content-between py-2">
            <a id="rwps__filter-drawer__anchor-point" href="#" class="sr-only" tabindex="-1">Filters Menu Open</a>
            <h2 class="rwps__filter-drawer__main-heading my-0">Filters</h2>
            <div class="rwps__filter-drawer__header-actions">
                <button
                    class="rwps__filter-drawer__reset-btn filter-btn"
                    @click="onFilterReset"
                    aria-label="Reset More Filters">
                    <i class="far fa-redo-alt d-inline-block mr-1"></i>
                    <span class="the-text">Reset Filter</span>
                </button>
                <template v-if="showClose">
                    <button
                        class="rwps__filter-drawer__close-btn filter-btn bg-secondary text-light border-secondary"
                        @click="$emit('filter-drawer-close')"
                        aria-label="Close More Filters Menu">
                        <i class="far fa-times d-inline-block mr-1"></i>
                        <span class="the-text">Close</span>
                    </button>
                </template>
            </div>
        </header>

        <div class="rwps__filter-drawer__filters-wrapper" :class="{ 'force-shown': isSearch == false }">
            <div class="p-lg-1">

                <template v-if="isSearch">
                  <span class="text-center">
                    <h4 class="font-weight-normal">
                      <template v-if="loading">
                        <i class="far fa-spin fa-spinner"></i>
                      </template>
                      <template v-else>
                        <template v-if="searchParams.location_txt">
                        {{currentCnt}} of {{totalCnt}} Result<template v-if="totalCnt !== 1">s</template>
                        </template>
                        <template v-else>
                          <i class="fal fa-search mr-1 text-primary"></i>Enter a location to begin your search
                        </template>
                      </template>
                    </h4>
                  </span>
                  <hr>

                </template>

                <div class="rwps__filter-row d-lg-none">
                    <h3 class="rwps__filter-row__label">Sort By</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <sort-by-control
                            :el-id="'rwps-filter-drawer-sort-input'"
                            :selected-field="searchParams.order_by"
                            :selected-direction="searchParams.order_dir"
                            :search-type="searchType"
                            @sort-change="$emit('sort-change', $event)"
                        ></sort-by-control>
                    </div>
                </div>
                
                <div class="rwps__filter-row d-lg-none">
                    <h3 class="rwps__filter-row__label">Search Type</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <label for="rwps-filter-drawer-listing-type-input" class="rwfc rwps__search-type-input-wrapper mb-0 mr-md-1">
                            <span class="sr-only">Search Type</span>
                            <div class="rwfc__dropdown-triangle-layer">
                              <select 
                                  id="rwps-filter-drawer-listing-type-input"
                                  class="rwfc__input"
                                  @change="$emit('search-type-change', $event.target.value)">
                                  <option value="for-sale" :selected="searchType == 'for-sale'">For Sale</option>
                                  <option value="for-rent" :selected="searchType == 'for-rent'">For Rent</option>
                              </select>
                            </div>
                        </label>
                    </div>
                </div>

                <!-- Price -->
                <div 
                class="rwps__filter-row"
                :class="{ 'd-lg-none': isSearch }">
                        <h3 class="rwps__filter-row__label">Price</h3>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-asking-price'"
                                :max-el-id="'rwps-filter-drawer-max-asking-price'"
                                :min-symbol-before="'$'"
                                :max-symbol-before="'$'"
                                :min-val="searchParams[`min_asking_price`]"
                                :max-val="searchParams[`max_asking_price`]"
                                :min-label="'Minimum Price'"
                                :max-label="'Maximum Price'"
                                @min-value-changed="emitFilterChange({[`min_asking_price`]: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({[`max_asking_price`]: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>

                    <!-- Beds -->
                    <div 
                    class="rwps__filter-row"
                    :class="{ 'd-lg-none': isSearch }">
                    <h3 class="rwps__filter-row__label">Beds</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <min-max-controls
                            :min-el-id="'rwps-filter-drawer-min-min_beds'"
                            :max-el-id="'rwps-filter-drawer-max-max_beds'"
                            :min-val="searchParams.min_beds"
                            :max-val="searchParams.max_beds"
                            :min-label="'Minimum Beds'"
                            :max-label="'Maximum Beds'"
                            @min-value-changed="emitFilterChange({min_beds: parseFloat($event)})"
                            @max-value-changed="emitFilterChange({max_beds: parseFloat($event)})">
                        </min-max-controls>
                    </div>
                </div>

                <!-- Baths -->
                <div class="rwps__filter-row">
                    <h3 class="rwps__filter-row__label">Baths</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <min-max-controls
                            :min-el-id="'rwps-filter-drawer-min-min_baths'"
                            :max-el-id="'rwps-filter-drawer-max-max_baths'"
                            :min-val="searchParams.min_baths"
                            :max-val="searchParams.max_baths"
                            :min-label="'Minimum Baths'"
                            :max-label="'Maximum Baths'"
                            @min-value-changed="emitFilterChange({min_baths: parseFloat($event)})"
                            @max-value-changed="emitFilterChange({max_baths: parseFloat($event)})">
                        </min-max-controls>
                    </div>
                </div>


                <!-- Baths -->
                <div class="rwps__filter-row">
                    <h3 class="rwps__filter-row__label">Year Built</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <min-max-controls
                            :min-el-id="'rwps-filter-drawer-min-min_year_built'"
                            :min-val="searchParams.min_year_built"
                            :hide-max="true"
                            :min-label="'Minimum Property Built Year'"
                            @min-value-changed="emitFilterChange({min_year_built: parseInt($event)})">
                        </min-max-controls>
                    </div>
                </div>

                <!-- Zipcodes -->
                <div class="rwps__filter-row rwps__filter-row--zipcodes">
                    <a class="sr-only anchor-point-offset" href="#rwps__filter-drawer__selected-zipcodes-anchor-point" aria-label="Please use the following text fields to indicate any zipcodes by which you would like to filter your search results"></a>
                    <h3 class="rwps__filter-row__label">Zipcodes</h3>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <select2-zipcodes 
                            :selected="selectedZipcodes"
                            @input="emitFilterChange({selected_zipcodes: $event})"
                            :min-lat="searchParams.min_lat"
                            :max-lat="searchParams.max_lat"
                            :min-lng="searchParams.min_lng"
                            :max-lng="searchParams.max_lng">
                        </select2-zipcodes>
                        <div class="mt-1">
                            <label for="rwps__filter-drawer__match-type-control">
                                <span class="sr-only" :aria-label="'How would you like to use your selected zipcodes, if applicable?'"></span>
                                <span class="sub-label-text the-text">I want to&nbsp;&nbsp;</span>
                                <span class="sr-only">{{ searchParams.match_type == 'i' ? 'include' : 'exclude' }}</span>
                                <select 
                                    id="rwps__filter-drawer__match-type-control" 
                                    class="select-small oa-form__input"
                                    @change="emitFilterChange({match_type: $event.target.value})">
                                    <option value="i" :selected="searchParams.match_type == 'i'">Include</option>
                                    <option value="e" :selected="searchParams.match_type == 'e'">Exclude</option>
                                </select>
                                <span class=" sub-label-text the-text">&nbsp;&nbsp;these zipcodes</span>
                            </label>
                        </div>
                    </div>
                </div>

                <template v-if="searchType == 'for-sale'">
                    <!-- Other -->
                    <div class="rwps__filter-row rwps__filter-row--zipcodes">
                        <h3 class="rwps__filter-row__label">Other</h3>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <div class="d-xxxl-flex">
                                <!-- <custom-checkbox 
                                    v-model="leasedPropertiesOnly"
                                    :label="'Tenant Occupied Properties Only'"
                                    :inputEl="'rwps-filter-drawer--rw-properties-only'"
                                    :css-classes="'mb-1'">
                                </custom-checkbox> -->
                                <custom-checkbox 
                                    v-model="isSection8"
                                    :label="'Section 8'"
                                    :inputEl="'rwps-filter-drawer--has-section-8'"
                                    :css-classes="''">
                                </custom-checkbox>
                            </div>
                        </div>
                    </div>
                </template>
                
            
            </div>

            <template v-if="searchType == 'for-sale'">
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--financials'"
                    :label="'Financials'"
                    :badge-text="financialFiltersLabel"
                    :is-active="true">

                    <!-- Net Yield -->
                    <div class="rwps__filter-row">
                        <h5 class="rwps__filter-row__label">Net Yield</h5>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-min_net_yield'"
                                :max-el-id="'rwps-filter-drawer-max-max_net_yield'"
                                :min-val="searchParams.min_net_yield"
                                :max-val="searchParams.max_net_yield"
                                :min-symbol-after="'%'"
                                :max-symbol-after="'%'"
                                :min-label="'Minimum Net Yield'"
                                :max-label="'Maximum Net Yield'"
                                @min-value-changed="emitFilterChange({min_net_yield: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({max_net_yield: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>

                    <!-- Gross Yield -->
                    <div 
                      class="rwps__filter-row"
                      :class="{ 'd-lg-none': isSearch }">
                        <h5 class="rwps__filter-row__label">Gross Yield</h5>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-min_gross_yield'"
                                :max-el-id="'rwps-filter-drawer-max-max_gross_yield'"
                                :min-val="searchParams.min_gross_yield"
                                :max-val="searchParams.max_gross_yield"
                                :max-symbol-after="'%'"
                                :min-symbol-after="'%'"
                                :min-label="'Minimum Gross Yield'"
                                :max-label="'Maximum Gross Yield'"
                                @min-value-changed="emitFilterChange({min_gross_yield: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({max_gross_yield: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>

                    <!-- Expense Load -->
                    <div class="rwps__filter-row">
                        <h5 class="rwps__filter-row__label">Expense Load</h5>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-min_expense_load'"
                                :max-el-id="'rwps-filter-drawer-max-max_expense_load'"
                                :min-val="searchParams.min_expense_load"
                                :max-val="searchParams.max_expense_load"
                                :max-symbol-after="'%'"
                                :min-symbol-after="'%'"
                                :min-label="'Minimum Expense Load'"
                                :max-label="'Maximum Expense Load'"
                                @min-value-changed="emitFilterChange({min_expense_load: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({max_expense_load: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>

                    <!-- HPA -->
                    <div class="rwps__filter-row">
                        <h5 class="rwps__filter-row__label">Home Price Appreciation</h5>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-min_hpa'"
                                :max-el-id="'rwps-filter-drawer-max-max_hpa'"
                                :min-val="searchParams.min_hpa"
                                :max-val="searchParams.max_hpa"
                                :max-symbol-after="'%'"
                                :min-symbol-after="'%'"
                                :min-label="'Minimum Expense Load'"
                                :max-label="'Maximum Expense Load'"
                                @min-value-changed="emitFilterChange({min_hpa: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({max_hpa: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>

                    <!-- Monthly Rent -->
                    <div class="rwps__filter-row">
                        <h5 class="rwps__filter-row__label">Monthly Rent</h5>
                        <div class="rwps__filter-row__inputs-wrapper">
                            <min-max-controls
                                :min-el-id="'rwps-filter-drawer-min-min_monthly_rent'"
                                :max-el-id="'rwps-filter-drawer-max-max_monthly_rent'"
                                :min-val="searchParams.min_monthly_rent"
                                :max-val="searchParams.max_monthly_rent"
                                :min-symbol-before="'$'"
                                :max-symbol-before="'$'"
                                :min-symbol-after="'/mo.'"
                                :max-symbol-after="'/mo.'"
                                :min-label="'Minimum Monthly Rent'"
                                :max-label="'Maximum Monthly Rent'"
                                @min-value-changed="emitFilterChange({min_monthly_rent: parseFloat($event)})"
                                @max-value-changed="emitFilterChange({max_monthly_rent: parseFloat($event)})">
                            </min-max-controls>
                        </div>
                    </div>
                    
                </collapsing-filter-group>
            </template>

            <collapsing-filter-group 
                :dropdown-id="'rwps__filter-drawer__collapsing-group--size'"
                :label="'Size'"
                :badge-text="sizeFiltersLabel"
                :is-active="true">

                <!-- Square Feet -->
                <div class="rwps__filter-row">
                    <h5 class="rwps__filter-row__label">Square Feet</h5>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <min-max-controls
                            :min-el-id="'rwps-filter-drawer-min-min_sqft'"
                            :max-el-id="'rwps-filter-drawer-max-max_sqft'"
                            :min-val="searchParams.min_sqft"
                            :max-val="searchParams.max_sqft"
                            :min-symbol-after="'sqft.'"
                            :max-symbol-after="'sqft.'"
                            :min-label="'Minimum Square Feet'"
                            :max-label="'Maximum Square Feet'"
                            @min-value-changed="emitFilterChange({min_sqft: parseFloat($event)})"
                            @max-value-changed="emitFilterChange({max_sqft: parseFloat($event)})">
                        </min-max-controls>
                    </div>
                </div>

                <!-- Lot Size -->
                <div class="rwps__filter-row">
                    <h5 class="rwps__filter-row__label">Lot Size</h5>
                    <div class="rwps__filter-row__inputs-wrapper">
                        <min-max-controls
                            :min-el-id="'rwps-filter-drawer-min-min_lot_size'"
                            :max-el-id="'rwps-filter-drawer-max-max_lot_size'"
                            :min-val="searchParams.min_lot_size"
                            :max-val="searchParams.max_lot_size"
                            :min-symbol-after="'sqft.'"
                            :max-symbol-after="'sqft.'"
                            :min-label="'Minimum Lot Size in square feet'"
                            :max-label="'Maximum Lot Size in square feet'"
                            @min-value-changed="emitFilterChange({min_lot_size: parseFloat($event)})"
                            @max-value-changed="emitFilterChange({max_lot_size: parseFloat($event)})">
                        </min-max-controls>
                    </div>
                </div>

            </collapsing-filter-group>

            <!-- AMENITIES -->
            <template v-if="searchType == 'for-rent'">
                
                <!-- INTERIOR -->
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--interior'"
                    :label="'Interior'"
                    :badge-text="interiorFiltersLabel"
                    :is-active="true">

                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasDiningArea"
                                :label="'Dining Area'"
                                :inputEl="'rwps-filter-drawer--has-dining-area'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasHighCeilings"
                                :label="'High Ceilings'"
                                :inputEl="'rwps-filter-drawer--has-high-ceilings'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasCeilingFans"
                                :label="'Ceiling Fans'"
                                :inputEl="'rwps-filter-drawer--has-ceiling-fans'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasWalkInClosets"
                                :label="'Walk-In Closets'"
                                :inputEl="'rwps-filter-drawer--has-walk-in-closets'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasGraniteCountertops"
                                :label="'Granite Countertops'"
                                :inputEl="'rwps-filter-drawer--has-granite-countertops'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasSatelliteTv"
                                :label="'Satellite TV'"
                                :inputEl="'rwps-filter-drawer--has-satellite-tv'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasCableReady"
                                :label="'Cable-ready'"
                                :inputEl="'rwps-filter-drawer--has-cable-ready'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasFireplace"
                                :label="'Fireplace'"
                                :inputEl="'rwps-filter-drawer--has-fireplace'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasStorage"
                                :label="'Storage'"
                                :inputEl="'rwps-filter-drawer--has-storage'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasIndoorJacuzzi"
                                :label="'Indor Jacuzzi'"
                                :inputEl="'rwps-filter-drawer--has-indoor-jacuzzi'">
                            </custom-checkbox>
                        </div>
                    </div>

                </collapsing-filter-group>

                <!-- FLOORING -->
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--flooring'"
                    :label="'Flooring'"
                    :badge-text="flooringFiltersLabel"
                    :is-active="true">

                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasCeramicTile"
                                :label="'Ceramic Tile'"
                                :inputEl="'rwps-filter-drawer--has-ceramic-tile'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasHardwoodFloors"
                                :label="'Hardwood Floors'"
                                :inputEl="'rwps-filter-drawer--has-hardwood-floors'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasNewCarpet"
                                :label="'New Carpet'"
                                :inputEl="'rwps-filter-drawer--has-new-carpet'">
                            </custom-checkbox>
                        </div>
                    </div>

                </collapsing-filter-group>

                <!-- KITCHEN -->
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--kitchen'"
                    :label="'Kitchen'"
                    :badge-text="kitchenFiltersLabel"
                    :is-active="true">

                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasStainlessSteelAppliances"
                                :label="'Stainless Steel Appliances'"
                                :inputEl="'rwps-filter-drawer--has-stainless-steel-appliances'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasEatInKitchen"
                                :label="'Eat-in Kitchen'"
                                :inputEl="'rwps-filter-drawer--has-eat-in-kitchen'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasOvenRange"
                                :label="'Oven/Range'"
                                :inputEl="'rwps-filter-drawer--has-oven-range'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasGarbageDisposal"
                                :label="'Garbage Disposal'"
                                :inputEl="'rwps-filter-drawer--has-garbage-disposal'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasRefrigerator"
                                :label="'Refrigerator'"
                                :inputEl="'rwps-filter-drawer--has-refrigerator'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasStove"
                                :label="'Stove'"
                                :inputEl="'rwps-filter-drawer--has-stove'">
                            </custom-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasDishwasher"
                                :label="'Dishwasher'"
                                :inputEl="'rwps-filter-drawer--has-dishwasher'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasMicrowave"
                                :label="'Microwave'"
                                :inputEl="'rwps-filter-drawer--has-microwave'">
                            </custom-checkbox>
                        </div>
                    </div>
                
                </collapsing-filter-group>

                <!-- LAUNDRY -->
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--laundry'"
                    :label="'Laundry'"
                    :badge-text="laundryFiltersLabel"
                    :is-active="true">

                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasWasher"
                                :label="'Washer'"
                                :inputEl="'rwps-filter-drawer--has-washer'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasDryer"
                                :label="'Dryer'"
                                :inputEl="'rwps-filter-drawer--has-dryer'">
                            </custom-checkbox>
                        </div>
                    </div>

                </collapsing-filter-group>

                <!-- HEATING / COOLING -->
                <collapsing-filter-group 
                    :dropdown-id="'rwps__filter-drawer__collapsing-group--heatingCooling'"
                    :label="'Heating / Cooling'"
                    :badge-text="heatingCoolingFiltersLabel"
                    :is-active="true">

                    <div class="row">
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasAirConditioning"
                                :label="'Air Conditioning'"
                                :inputEl="'rwps-filter-drawer--has-air-conditioning'">
                            </custom-checkbox>
                        </div>
                        <div class="col-lg">
                            <custom-checkbox 
                                v-model="hasCentralHeating"
                                :label="'Central Heating'"
                                :inputEl="'rwps-filter-drawer--has-central-heating'">
                            </custom-checkbox>
                        </div>
                    </div>
                    
                </collapsing-filter-group>

            </template>
        

        </div>
        
        
    </div>
</template>

<script>
import { mapState } from 'vuex';
import PropertySearchFiltersMixin from '@vue/mixins/property-search-filters-mixin';

import MinMaxControls from '@vue/components/inputs/MinMaxControls.vue';
import CustomCheckbox from '@vue/components/inputs/CustomCheckbox.vue';
import CollapsingFilterGroup from '@vue/components/rwps/CollapsingFilterGroup.vue';
import Select2Zipcodes from '@vue/components/select2/Select2ZipCodes.vue';
import SortByControl from '@vue/components/rwps/SortByControl.vue';

export default {
    components: {
        MinMaxControls, 
        CollapsingFilterGroup,
        CustomCheckbox,
        Select2Zipcodes,
        SortByControl
    },
    mixins: [PropertySearchFiltersMixin],
    props: {
      showClose: {},
      searchType: {},
      isSearch: {},
      currentCnt: {},
      totalCnt: {},
      loading: {},
      buildingTypeDropdownOptions: { type: Object, required: true}
    },
    data(){
        return {
            fieldsToReset: {
                emptyString: [
                    'max_baths',
                    'min_baths',
                    'min_net_yield',
                    'max_net_yield',
                    'min_gross_yield',
                    'max_gross_yield',
                    'min_expense_load',
                    'max_expense_load',
                    'min_hpa',
                    'max_hpa',
                    'min_monthly_rent',
                    'max_monthly_rent',
                    'min_sqft',
                    'max_sqft',
                    'min_lot_size',
                    'max_lot_size',
                    'min_year_built',
                ],
                boolean: [
                    'section8',
                    // 'leased_properties_only',
                    'has_dining_area',
                    'has_high_ceilings',
                    'has_ceiling_fans',
                    'has_walk_in_closets',
                    'has_granite_countertops',
                    'has_satellite_tv',
                    'has_cable_ready',
                    'has_fireplace',
                    'has_storage',
                    'has_indoor_jacuzzi',
                    'has_views',
                    'has_ceramic_tile',
                    'has_hardwood_floors',
                    'has_new_carpet',
                    'has_washer',
                    'has_dryer',
                    'has_stainless_steel_appliances',
                    'has_eat_in_kitchen',
                    'has_oven_range',
                    'has_garbage_disposal',
                    'has_refrigerator',
                    'has_stove',
                    'has_dishwasher',
                    'has_microwave',
                    'has_ac',
                    'has_central_heating',
                ],
                emptyArr: [
                    'selected_zipcodes'
                ]
            }
        }
    },
    computed: {
        ...mapState('propertySearchStore', [
            'searchParams',
            'fieldGroups',
        ]),

        hasDiningArea: {
            get(){ return this.searchParams.has_dining_area; },
            set(value){ this.$emit('filter-change', {has_dining_area: value}); }
        },
        hasHighCeilings: {
            get(){ return this.searchParams.has_high_ceilings; },
            set(value){ this.$emit('filter-change', {has_high_ceilings: value}); }
        },
        hasCeilingFans: {
            get(){ return this.searchParams.has_ceiling_fans; },
            set(value){ this.$emit('filter-change', {has_ceiling_fans: value}); }
        },
        hasWalkInClosets: {
            get(){ return this.searchParams.has_walk_in_closets; },
            set(value){ this.$emit('filter-change', {has_walk_in_closets: value}); }
        },
        hasGraniteCountertops: {
            get(){ return this.searchParams.has_granite_countertops; },
            set(value){ this.$emit('filter-change', {has_granite_countertops: value}); }
        },
        hasSatelliteTv: {
            get(){ return this.searchParams.has_satellite_tv; },
            set(value){ this.$emit('filter-change', {has_satellite_tv: value}); }
        },
        hasCableReady: {
            get(){ return this.searchParams.has_cable_ready; },
            set(value){ this.$emit('filter-change', {has_cable_ready: value}); }
        },
        hasFireplace: {
            get(){ return this.searchParams.has_fireplace; },
            set(value){ this.$emit('filter-change', {has_fireplace: value}); }
        },
        hasStorage: {
            get(){ return this.searchParams.has_storage; },
            set(value){ this.$emit('filter-change', {has_storage: value}); }
        },
        hasIndoorJacuzzi: {
            get(){ return this.searchParams.has_indoor_jacuzzi; },
            set(value){ this.$emit('filter-change', {has_indoor_jacuzzi: value}); }
        },
        hasCeramicTile: {
            get(){ return this.searchParams.has_ceramic_tile; },
            set(value){ this.$emit('filter-change', {has_ceramic_tile: value}); }
        },
        hasHardwoodFloors: {
            get(){ return this.searchParams.has_hardwood_floors; },
            set(value){ this.$emit('filter-change', {has_hardwood_floors: value}); }
        },
        hasNewCarpet: {
            get(){ return this.searchParams.has_new_carpet; },
            set(value){ this.$emit('filter-change', {has_new_carpet: value}); }
        },
        hasStainlessSteelAppliances: {
            get(){ return this.searchParams.has_stainless_steel_appliances; },
            set(value){ this.$emit('filter-change', {has_stainless_steel_appliances: value}); }
        },
        hasEatInKitchen: {
            get(){ return this.searchParams.has_eat_in_kitchen; },
            set(value){ this.$emit('filter-change', {has_eat_in_kitchen: value}); }
        },
        hasOvenRange: {
            get(){ return this.searchParams.has_oven_range; },
            set(value){ this.$emit('filter-change', {has_oven_range: value}); }
        },
        hasGarbageDisposal: {
            get(){ return this.searchParams.has_garbage_disposal; },
            set(value){ this.$emit('filter-change', {has_garbage_disposal: value}); }
        },
        hasRefrigerator: {
            get(){ return this.searchParams.has_refrigerator; },
            set(value){ this.$emit('filter-change', {has_refrigerator: value}); }
        },
        hasStove: {
            get(){ return this.searchParams.has_stove; },
            set(value){ this.$emit('filter-change', {has_stove: value}); }
        },
        hasDishwasher: {
            get(){ return this.searchParams.has_dishwasher; },
            set(value){ this.$emit('filter-change', {has_dishwasher: value}); }
        },
        hasMicrowave: {
            get(){ return this.searchParams.has_microwave; },
            set(value){ this.$emit('filter-change', {has_microwave: value}); }
        },
        hasWasher: {
            get(){ return this.searchParams.has_washer; },
            set(value){ this.$emit('filter-change', {has_washer: value}); }
        },
        hasDryer: {
            get(){ return this.searchParams.has_dryer; },
            set(value){ this.$emit('filter-change', {has_dryer: value}); }
        },
        hasAirConditioning: {
            get(){ return this.searchParams.has_ac; },
            set(value){ this.$emit('filter-change', {has_ac: value}); }
        },
        hasCentralHeating: {
            get(){ return this.searchParams.has_central_heating; },
            set(value){ this.$emit('filter-change', {has_central_heating: value}); }
        },
        hasViews: {
            get(){ return this.searchParams.has_views; },
            set(value){ this.$emit('filter-change', {has_views: value}); }
        },
        // leasedPropertiesOnly: {
        //     get(){ return this.searchParams.leased_properties_only; },
        //     set(value){ this.$emit('filter-change', {leased_properties_only: value}); }
        // },
        isSection8: {
            get(){ return this.searchParams.section8; },
            set(value){ this.$emit('filter-change', {section8: value}); }
        },
        selectedZipcodes: {
            get(){ return this.searchParams.selected_zipcodes; },
            set(value){ this.$emit('filter-change', {selected_zipcodes: value}); }
        },

        financialFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.financials.includes(field));
        },
        financialFiltersLabel(){
            if(!this.financialFilters || this.financialFilters.length == 0) return false;
            return this.financialFilters.length > 1 ? `${this.financialFilters.length} active` : this.financialFilters[0].displayName;
        },

        interiorFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.interior.includes(field));
        },
        interiorFiltersLabel(){
            if(!this.interiorFilters || this.interiorFilters.length == 0) return false;
            return this.interiorFilters.length > 1 ? `${this.interiorFilters.length} active` : this.interiorFilters[0].displayName;
        },

        flooringFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.flooring.includes(field));
        },
        flooringFiltersLabel(){
            if(!this.flooringFilters || this.flooringFilters.length == 0) return false;
            return this.flooringFilters.length > 1 ? `${this.flooringFilters.length} active` : this.flooringFilters[0].displayName;
        },

        kitchenFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.kitchen.includes(field));
        },
        kitchenFiltersLabel(){
            if(!this.kitchenFilters || this.kitchenFilters.length == 0) return false;
            return this.kitchenFilters.length > 1 ? `${this.kitchenFilters.length} active` : this.kitchenFilters[0].displayName;
        },

        sizeFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.size.includes(field));
        },
        sizeFiltersLabel(){
            if(!this.sizeFilters || this.sizeFilters.length == 0) return false;
            return this.sizeFilters.length > 1 ? `${this.sizeFilters.length} active` : this.sizeFilters[0].displayName;
        },

        laundryFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.laundry.includes(field));
        },
        laundryFiltersLabel(){
            if(!this.laundryFilters || this.laundryFilters.length == 0) return false;
            return this.laundryFilters.length > 1 ? `${this.laundryFilters.length} active` : this.laundryFilters[0].displayName;
        },

        heatingCoolingFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.heatingCooling.includes(field));
        },
        heatingCoolingFiltersLabel(){
            if(!this.heatingCoolingFilters || this.heatingCoolingFilters.length == 0) return false;
            return this.heatingCoolingFilters.length > 1 ? `${this.heatingCoolingFilters.length} active` : this.heatingCoolingFilters[0].displayName;
        },

        otherFilters(){
            if(!this.activeFilters) return false;
            return this.activeFilters.filter(({field}) => this.fieldGroups.other.includes(field));
        },
        otherFiltersLabel(){
            if(!this.otherFilters || this.otherFilters.length == 0) return false;
            return this.otherFilters.length > 1 ? `${this.otherFilters.length} active` : this.otherFilters[0].displayName;
        },

        filterDrawerActiveCount(){
            return this.financialFilters.length + 
                    this.sizeFilters.length + 
                    this.interiorFilters.length + 
                    this.flooringFilters.length + 
                    this.kitchenFilters.length + 
                    this.heatingCoolingFilters.length + 
                    this.otherFilters.length +
                    this.searchParams.selected_zipcodes.length;
        }
    },

    methods: {
        onFilterReset(){
            let emptyStringParams = {};
            let booleanParams = {};

            this.fieldsToReset.emptyString.map(field => {
                emptyStringParams[field] = '';
            });
            this.fieldsToReset.boolean.map(field => {
                booleanParams[field] = false;
            });
            
            this.fieldsToReset.emptyArr.map(field => {
                booleanParams[field] = [];
            });

            this.$emit('filter-drawer-reset', {...emptyStringParams, ...booleanParams});
        }
    },

    watch: {
        filterDrawerActiveCount(value){
            console.log('changed', value);
            this.$emit('update-filter-drawer-active-count', value);
        }
    }
}
</script>